(function() {
  'use strict';

  const ITEMS_PER_PAGE = 5;

  function initProductFAQ() {
    const faqSections = document.querySelectorAll('.product-faq-accordion[data-faq-section]');
    
    faqSections.forEach(accordion => {
      const readMoreBtn = accordion.closest('.product-faq-accordion-wrapper')?.querySelector('.product-faq-read-more');
      
      if (!readMoreBtn) return;

      // Only allow one FAQ item open at a time
      const faqItems = accordion.querySelectorAll('.product-faq-item');
      faqItems.forEach(item => {
        item.addEventListener('toggle', function() {
          if (this.open) {
            // Close all other items
            faqItems.forEach(otherItem => {
              if (otherItem !== this && otherItem.open) {
                otherItem.open = false;
              }
            });
          }
        });
      });

      // Read more button functionality
      readMoreBtn.addEventListener('click', function() {
        const hiddenItems = accordion.querySelectorAll('.product-faq-item--hidden');
        const itemsToShow = Array.from(hiddenItems).slice(0, ITEMS_PER_PAGE);
        
        itemsToShow.forEach(item => {
          item.classList.remove('product-faq-item--hidden');
        });

        // Hide button if no more items to show
        const remainingHidden = accordion.querySelectorAll('.product-faq-item--hidden');
        if (remainingHidden.length === 0) {
          readMoreBtn.classList.add('hidden');
        }
      });
    });
  }

  // Initialize on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initProductFAQ);
  } else {
    initProductFAQ();
  }

  // Re-initialize for dynamic content (e.g., theme editor)
  if (Shopify && Shopify.designMode) {
    document.addEventListener('shopify:section:load', initProductFAQ);
    document.addEventListener('shopify:section:reorder', initProductFAQ);
  }
})();
